import { STOCK_TYPE_TO_LABEL } from "../constants"

import { type ProductStockType } from "@/graphql/codegen/graphql"

export const formatStockType = (stockType: ProductStockType | null | undefined): string => {
  if (!stockType) return ""
  return STOCK_TYPE_TO_LABEL[stockType] ?? stockType
}
